import React, {FC} from 'react';
import styled from 'styled-components';

import {Button} from '../../../../../../libs/shared/ui/src/components/buttons/button';
import {VisualSizesEnum} from '../../../../../../libs/shared/ui/src/styles/commonStyles';
import {IntegrationIcon} from '../../../../common/integrationIcon';
import {CellsEmptySetupActionsDefinition} from './cellsEmptyCommon';

/*
 * Style.
 */

const StyledButtonWrapperDiv = styled.div`
  margin-bottom: 10px;
`;

const StyledWrapperDiv = styled.div`
  display: grid;
  grid-template-areas: 'icon text';
  align-items: center;
  grid-column-gap: 6px;
`;

const StyledIconDiv = styled(IntegrationIcon)`
  grid-area: icon;
  margin: -2px 0;
  transform: translateY(0.5px);
`;

const StyledTextDiv = styled.div`
  grid-area: text;
  margin-right: 4px;
`;

/*
 * Component.
 */

export const CellsEmptySetupActionsButton: FC<CellsEmptySetupActionsDefinition> = ({
  buttonVariant,
  title,
  onClick,
  integrationIcon,
  interactionId,
}) => (
  <StyledButtonWrapperDiv>
    <Button
      variant={buttonVariant}
      onClick={onClick}
      size={VisualSizesEnum.MEDIUM}
      interactionId={interactionId}
    >
      <StyledWrapperDiv>
        {integrationIcon !== undefined && <StyledIconDiv integrationIcon={integrationIcon} />}
        <StyledTextDiv>{title}</StyledTextDiv>
      </StyledWrapperDiv>
    </Button>
  </StyledButtonWrapperDiv>
);
